import { useMemo } from 'react';

import { useGraphQLResponseMessage } from '@/src/components/hooks/useGraphqlResponseMessage';
import { useLearnerRapsQuery } from '@/src/generated/operations/LearnerRapsQuery.generated';

export const useLearnerRapsQueryData = () => {
  const context = useMemo(
    () => ({
      additionalTypenames: ['RegisteredApprenticeshipProgram'],
    }),
    [],
  );

  const [query] = useLearnerRapsQuery({
    context,
  });

  useGraphQLResponseMessage(query, {
    errorMessage: 'There was a problem loading RAPs',
  });

  const raps = query.data?.assignedRaps ?? [];

  return {
    fetching: query.fetching,
    raps,
  };
};
